import React, { useMemo, useState } from "react";
import { resolveDestinationFlagImageUrl } from "../../../utils/resolveCountryFlagFromLds";
import "./CountryFlag.scss";

/**
 * @param {string} [destinationCode] — LDS city/airport code
 * @param {string} [countryCode] — ISO-3166 alpha-2 override
 * @param {'20x15'|'24x18'|'32x24'|'w40'} [size='24x18']
 */
export default function CountryFlag({
  destinationCode,
  countryCode,
  size = "24x18",
  className = "",
  title = "",
}) {
  const [hidden, setHidden] = useState(false);
  const flagUrl = useMemo(
    () => resolveDestinationFlagImageUrl({ destinationCode, countryCode }, size),
    [destinationCode, countryCode, size],
  );

  if (!flagUrl || hidden) return null;

  return (
    <img
      src={flagUrl}
      alt=""
      className={["hr-country-flag", className].filter(Boolean).join(" ")}
      loading="lazy"
      decoding="async"
      title={title || undefined}
      aria-hidden={title ? undefined : true}
      onError={() => setHidden(true)}
    />
  );
}
